export class AberturaCaixaRequest {
    constructor(
        public codigoUsuario: number,
        public valorAbertura: number,
        public numeroCaixa: number
    ) { }
}
